import { faCalendarXmark } from "@fortawesome/duotone-light-svg-icons"
import { Button } from "@joonapp/web-shared"
import { SessionBooking } from "@joonapp/web-shared"

import useUserRole from "../../../../hooks/useUserRole"
import useSession from "../hooks/useSession"

const CancelSessionButton = ({ session }: { session: SessionBooking }) => {
  const { handleCancelSession, showCancelButton } = useSession(session)

  const { isClientOfOtherCoach } = useUserRole()
  if (!showCancelButton) return <></>

  return (
    <Button
      text="Cancel session"
      buttonType="redSecondary"
      icon={faCalendarXmark}
      onClick={handleCancelSession}
      disabled={isClientOfOtherCoach}
    />
  )
}

export default CancelSessionButton
